import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifc-app-bar-expanded-tabs',
    templateUrl: './app-bar-expanded-tabs.component.html',
    styleUrls: ['./app-bar-expanded-tabs.component.scss'],
    standalone: false
})
export class AppBarExpandedTabsComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  data: AppBarExpandedTabsComponentData;

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe((it: AppBarExpandedTabsComponentData) => this.data = it);
  }

  get tabs() {
    if (
      !this.data ||
      !this.data.appBarExpandedTabs ||
      !this.data.appBarExpandedTabs.tabs ||
      !this.data.appBarExpandedTabs.tabs.length
    )
      return [];

    return this.data.appBarExpandedTabs.tabs.filter(it => !it.hidden
      && (!it.loanStatusNotAllowed?.includes(this.data?.account?.status) || this.data?.accessNPLEconomics));
  }
}

export interface AppBarExpandedTab {
  hidden?: boolean;
  label: string;
  url: string;
  query?: any;
  loanStatusNotAllowed?: any[]
}

export interface AppBarExpandedTabsComponentData {
  account?: any;
  accessNPLEconomics?: boolean;
  appBarExpandedTabs: {
    tabs: AppBarExpandedTab[];
  };
}
